<template>
  <div class="zch-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZchFooter'
}
</script>